/**
 * Not used atm when starting to use make sure to add the proper typing to window.d.ts for the window variable
 * import "./site/google";
 */

import FloatingButtons from "./site/Components/FloatingButtons.vue";

import.meta.glob(["../images/**"]);

import { createPinia } from "pinia";

const pinia = createPinia();

import { createApp } from "vue/dist/vue.esm-bundler.js";
import { useLabelStore } from "./site/stores/label";

const app = createApp({
    mounted() {
        // flash_session();
    },
    created() {
        const labelStore = useLabelStore();
        labelStore.setFromJsonString(window.labels);
    },
});

app.use(pinia);

import { defineAsyncComponent } from "vue";
import vue3StarRatings from "vue3-star-ratings";
import EnrollmentForm from "./site/Components/Enrollment/EnrollmentForm.vue";
import KnowledgeSort from "./site/Components/Knowledge/KnowledgeSort.vue";
import Messages from "./site/Components/Messages.vue";
import Modal from "./site/Components/Modal.vue";
import CourseOverview from "./site/Components/Product/CourseOverview.vue";
import ProductCarousel from "./site/Components/Product/ProductCarousel.vue";
import ProductCarouselGrid from "./site/Components/Product/ProductCarouselGrid.vue";
import Quote from "./site/Components/Quote.vue";
import SearchBar from "./site/Components/Search/SearchBar.vue";
import SearchToggle from "./site/Components/Search/SearchToggle.vue";

app.component(
    "address-input",
    defineAsyncComponent(
        () => import("./site/Components/Address/AddressEntityInput.vue"),
    ),
)
    .component(
        "address-selector",
        defineAsyncComponent(
            () => import("./site/Components/Address/AddressSelector.vue"),
        ),
    )
    .component("vue3-star-ratings", vue3StarRatings)
    .component(
        "address-list",
        defineAsyncComponent(
            () => import("./site/Components/Address/AddressList.vue"),
        ),
    )
    .component(
        "address-item",
        defineAsyncComponent(
            () => import("./site/Components/Address/AddressItem.vue"),
        ),
    )
    .component("modal", Modal)
    .component(
        "product",
        defineAsyncComponent(
            () => import("./site/Components/Product/Product.vue"),
        ),
    )
    .component(
        "product-overview",
        defineAsyncComponent(
            () => import("./site/Components/Product/ProductOverview.vue"),
        ),
    )
    .component(
        "contact-form",
        defineAsyncComponent(
            () => import("./site/Components/Form/ContactForm.vue"),
        ),
    )
    .component(
        "contact-form-employee",
        defineAsyncComponent(
            () => import("./site/Components/Form/ContactFormEmployee.vue"),
        ),
    )
    .component(
        "newsletter-form",
        defineAsyncComponent(
            () => import("./site/Components/Form/NewsletterForm.vue"),
        ),
    )
    .component("search-bar", SearchBar)
    .component("search-toggle", SearchToggle)
    .component(
        "video-wrapper",
        defineAsyncComponent(
            () => import("./site/Components/VideoWrapper.vue"),
        ),
    )
    .component("quote", Quote)
    .component("enrollment-form", EnrollmentForm)
    // Async / lazy load components
    .component(
        "skeleton",
        defineAsyncComponent(() => import("./site/Components/Skeleton.vue")),
    )
    .component(
        "prevent-interaction",
        defineAsyncComponent(
            () => import("./site/Components/PreventInteraction.vue"),
        ),
    )
    .component(
        "carousel",
        defineAsyncComponent(() => import("./site/Components/Carousel.vue")),
    )
    .component(
        "carousel-item",
        defineAsyncComponent(
            () => import("./site/ui/carousel/CarouselItem.vue"),
        ),
    )
    .component(
        "selected-icon",
        defineAsyncComponent(
            () => import("./site/Components/SelectedIcon.vue"),
        ),
    )
    .component("messages", Messages)
    .component("floating-buttons", FloatingButtons)
    .component("product-carousel", ProductCarousel)
    .component("product-carousel-grid", ProductCarouselGrid)
    .component(
        "carousel-grid",
        defineAsyncComponent(() => import("./site/Components/CarouselGrid.vue")),
    )
    .component("knowledge-sort", KnowledgeSort)
    .component("course-overview", CourseOverview)
    .component(
        "offer-form",
        defineAsyncComponent(
            () => import("./site/Components/Form/OfferForm.vue"),
        ),
    )
    .component(
        "location-overview",
        defineAsyncComponent(
            () => import("./site/Components/Location/LocationOverview.vue"),
        ),
    )
    .component(
        "vacancies",
        defineAsyncComponent(() => import("./site/Components/Vacancies.vue")),
    )
    .component(
        "circle-steps",
        defineAsyncComponent(() => import("./site/Components/CircleSteps.vue")),
    )
    .component(
        "faq-list",
        defineAsyncComponent(
            () => import("./site/Components/Product/FaqList.vue"),
        ),
    )
    .component(
        "reviews",
        defineAsyncComponent(
            () => import("./site/Components/Product/Reviews.vue"),
        ),
    )
    .component(
        "flag",
        defineAsyncComponent(() => import("./site/ui/Flag.vue")),
    )
    .component(
        "course-helper",
        defineAsyncComponent(
            () => import("./site/Components/CourseHelper.vue"),
        ),
    );

app.mount("#app");
